import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, DBRadioButton } from '_components';
import styles from './Common.module.css';
import {
    PatientCareCenterNoteAssessmentFreeForm,
    PatientCareCenterNoteNewAssessment,
    PatientCareCenterNoteAssessmentOutcomes,
    PatientCareCenterNoteAssessmentOrthosis,
    PatientCareCenterNoteAssessmentBarriers,
    PatientCareCenterNoteAssessmentEval,
    PatientCareCenterNoteAssessmentDN,
    PatientCareCenterNoteAssessmentPN,
    PatientCareCenterNoteAssessmentDC,
} from 'PatientCareCenter/Note/Assessment'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';


class PatientCareCenterNoteAssessment extends React.Component {

    componentDidMount() {
        if ((this.props.ass.ASISBUILDER === undefined || this.props.ass.ASISBUILDER === null) && this.props.ass.ASOLD) {
            this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASISBUILDER', true);
        }
    }

    componentDidUpdate(prevProps) {
        if ((this.props.ass.ASISBUILDER === undefined || this.props.ass.ASISBUILDER === null) && this.props.ass.ASOLD) {
            this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASISBUILDER', true);
        }
    }


    handleDiagChange(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASAWAREDIAG');
        }
        else if (event.target.value !== this.props.diagVal) {
            if (event.target.value === '1') {
                this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASAWAREDIAG', true);
            } else {
                this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASAWAREDIAG', false);
            }
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='assessment' name='Assessment' refProp={this.props.refProp}>
                {this.props.noteType === 1 &&
                    <span className={styles.container}>
                        <label className={styles.required_txt}>Rehab potential is&nbsp;</label>
                        <DBDropDown
                            className={styles.rehab_drop_down}
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.ass.ASNO}
                            field='ASREHABPOTENTIAL'
                            masterEntity='PTMASTERREHABPOT'
                            masterEntityKeyColumn='RPNO'
                            masterEntitySort='RPORDER'
                            masterEntityDisplay='RPNAME'
                        />
                        <label className={styles.required}>.&nbsp;</label>
                        {!this.props.isPeds &&
                            <label className={styles.required}>Patient&nbsp;</label>
                        }
                        {this.props.isPeds &&
                            <label className={styles.required}>Caregiver&nbsp;</label>
                        }
                        <select className={styles.diag_drop_down} value={this.props.diagVal ? this.props.diagVal : '-1'} onChange={(event) => this.handleDiagChange(event)}>
                            <option key={-1} value='-1'></option>
                            <option key={1} value='1'>is</option>
                            <option key={2} value='2'>is not</option>
                        </select>
                        <label className={styles.required}>&nbsp;aware of the diagnosis/prognosis.</label>
                    </span>
                }


                {this.props.ass.ASOLD &&
                    <>
                        <span className={styles.row}>

                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASISBUILDER'
                                className={styles.radio_old}
                                selectedValue={true}
                                label='Assessment Builder'
                            />
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASISBUILDER'
                                className={styles.radio_old}
                                selectedValue={false}
                                label='Free-Form Assessment'
                            />
                        </span>

                        {!this.props.ass.ASISBUILDER &&
                            <PatientCareCenterNoteAssessmentFreeForm />
                        }
                        {this.props.ass.ASISBUILDER &&
                            <>
                                {this.props.noteType === 1 &&
                                    <PatientCareCenterNoteAssessmentEval />
                                }
                                {this.props.noteType === 2 &&
                                    <PatientCareCenterNoteAssessmentDN />
                                }
                                {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                    <PatientCareCenterNoteAssessmentPN />
                                }
                                {(this.props.noteType === 4 || this.props.noteType === 6) &&
                                    <PatientCareCenterNoteAssessmentDC />
                                }
                            </>
                        }
                    </>
                }
                {!this.props.ass.ASOLD &&
                    <PatientCareCenterNoteNewAssessment />
                }

                {this.props.noteType !== 2 &&
                    <PatientCareCenterNoteAssessmentOutcomes outcomesRef={this.props.outcomesRef} />
                }
                {this.props.noteType === 1 &&
                    <PatientCareCenterNoteAssessmentOrthosis />
                }
                {(this.props.noteType === 3 || this.props.noteType === 4 || this.props.noteType === 5 || this.props.noteType === 6) &&
                    <PatientCareCenterNoteAssessmentBarriers />
                }
            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let ass = state.entities.notes.PTASSESSMENT[asno];

    let diagVal = state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG !== null ? state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG === true ? '1' : '2' : undefined;

    return {
        noteType,
        noteId,
        isPeds,
        ass,
        diagVal
    };
}

const connectedPatientCareCenterNoteAssessment = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteAssessment);
export { connectedPatientCareCenterNoteAssessment as PatientCareCenterNoteAssessment };

